<template>
  <div class=" container-fluid">
    <Tracker :data="trackerData"/>
    <div
      v-if="current==1"
    >
      <Introduction @next-question="onNextQuestion" :data="qData" />
    </div>

    <div v-if="current==2">
      <InformedConsent @next-question="onNextQuestion" :data="qData" />
    </div>

    <div v-if="isRadio(current)" :key="current">
      <Radio @next-question="onNextQuestion" @previous-question="onPreviousQuestion" @unique-answer="onUniqueAnswer" :uniqueI="uniqueInputs[`q${qData.ID}`]" :data="qData" :nextQ='next' :prevQ='previous' :user="user" :answers="answers[`Q${qData.ID}`]" />
    </div>

    <div v-if="current==4">
      <FillForm @next-question="onNextQuestion" @previous-build="onPreviousBuild" :user="user" @build-user="onBuildUser" :data="qData" :nextQ='next' :prevQ='previous' />
    </div>

     <div v-if="isMatrix(current)">
      <MatrixQuestion @next-question="onNextQuestion" @previous-question="onPreviousQuestion" :data="qData" :nextQ='next' :prevQ='previous' :answers="answers[`Q${qData.ID}`]"  :user="user" />
    </div>

    <div v-if="isShortA(current)">
      <ShortAnswer @next-question="onNextQuestion" @previous-question="onPreviousQuestion" @unique-answer="onUniqueAnswer" :data="qData" :nextQ='next' :user="user" :answers="uniqueInputs[`q${qData.ID}`]" :prevQ='previous'/>
    </div>

    <div v-if="isCheckA(current)" :key="current">
      <CheckAll @next-question="onNextQuestion" @previous-question="onPreviousQuestion" @unique-answer="onUniqueAnswer" :uniqueI="uniqueInputs[`q${qData.ID}`]" :data="qData" :nextQ='next' :user="user" :prevQ='previous' :answers="answers[`Q${qData.ID}`]"/>
    </div>
    <div v-if="current==23">
      <Conclusion @advance="onAdvance" :data="qData"/>
    </div>

  </div>
</template>
<script>
import store from "../../store.js";
import Introduction from "./Introduction.vue";
import InformedConsent from "./InformedConsent.vue";
import Radio from "./Radio.vue"
import FillForm from "./FillForm.vue"
import MatrixQuestion from "./MatrixQuestion.vue"
import ShortAnswer from "./ShortAnswer.vue"
import CheckAll from "./CheckAll.vue"
import Conclusion from "./Conclusion.vue"
import Tracker from "../Tracker.vue";
export default {
  name: "SurveyContainer",
  components: { Introduction, InformedConsent, Radio, FillForm, MatrixQuestion,ShortAnswer, CheckAll, Conclusion, Tracker},
  props: ["currentQ", "questionData"],
  setup() {
    // fetch("https://nsc-org-dev.azurewebsites.net/Survey/GetSurveys",{
    //                 method: "GET",
    //                 mode: "cors",
    //                 cache: "no-cache",
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
    //                 }}).then(data=> {return data.json()}).then(data=>console.log(data))

    // fetch('https://nsc-org-dev.azurewebsites.net/survey/upsertuser', {
    //                 method: "POST",
    //                 mode: "cors",
    //                 cache: "no-cache",
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
    //                 },body: JSON.stringify({ 
    //                      FirstName: 'jarret', 
    //                      LastName: 'berman', 
    //                      Company:'dunch inc',
    //                      EmailId:'jarretberman@gmail.com'
    //                      })}).then(data=> {return data.json()}).then(data=>console.log(data))

    // fetch('https://nsc-org-dev.azurewebsites.net/survey/checkuser?emailID=jarretberman@gmail.com', {
    //                 method: "GET",
    //                 mode: "cors",
    //                 cache: "no-cache",
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
    //                 }}).then(data=> {return data.json()}).then(data=>console.log(data))

    
    // store.getSurveys()
  },
  data(){
      return{
          current:this.currentQ,
          previous:0,
          next: 0,
          qData: this.questionData,
          trackerData: store.state.trackerVal,
          answers: store.state.surveyAnswers,
          uniqueInputs: store.state.uniqueAnswers,
          user: {
            company: "",
            subsector: "",
            firstName: "",
            lastName: "",
            email: "",
          }
      }
  },
  methods: {
    onNextQuestion(val,answer) {
        // console.log(val, answer)
      if(store.state.surveyAnswers[`Q${this.current}`] == undefined){
        store.updateTracker(val)
      }
      if([7,8,9].includes(this.current)){
        store.updateSurveyAnswers(`Q7`, null)
        store.updateSurveyAnswers(`Q8`, null)
        store.updateSurveyAnswers(`Q9`, null)
      }
      store.updateSurveyAnswers(`Q${this.current}`, answer)  
      store.updateCurrentQ(val);
      
      this.current = store.state.currentQ
      this.previous = store.state.previousQ
      this.answers = store.state.surveyAnswers
      this.qData = store.state.questionData
      this.next = val+1
      window.scrollTo(0,this.scroll)

  
      // console.log("answers:",store.state.surveyAnswers)

    },
    onPreviousQuestion(val, answer) {
      store.updateSurveyAnswers(`Q${this.current}`, answer)
      store.updateCurrentQ(val);
      this.current = store.state.currentQ
      this.previous = store.state.previousQ
      this.qData = store.state.questionData
      this.answers = store.state.surveyAnswers
      this.next = val+1  
      window.scrollTo(0,this.scroll)

  
      // console.log("question:",this.qData)

    },
    onBuildUser(obj){
        this.user = {
            company: obj.q1,
            subsector: obj.q2,
            firstName: obj.q3,
            lastName: obj.q4,
            email: obj.q5,
        }
    },
    onPreviousBuild(val,obj){
      
      this.user = {
            company: obj.q1 ? obj.q1 : "",
            subsector: obj.q2 ? obj.q2 : "",
            firstName: obj.q3 ? obj.q3 : "",
            lastName: obj.q4 ? obj.q4 : "",
            email: obj.q5 ? obj.q5 : "",
        }
      store.updateCurrentQ(val);
      this.current = store.state.currentQ
      this.previous = store.state.previousQ
      this.qData = store.state.questionData
      this.answers = store.state.surveyAnswers
      this.next = val+1
      window.scrollTo(0,this.scroll)

    

    },
    async onAdvance(){
        let uriInfo = store.getURIInfo(store.state.surveyAnswers)
        // console.log(store.state.surveyAnswers)
        // let Q14 = store.state.surveyAnswers["Q14"]
      let resultsurl = `https://`+window.location.host+window.location.pathname+'?#/results?'+
                        `11=${uriInfo['11']}` +
                        `&12=${uriInfo['12']}` +
                        `&13=${uriInfo['13']}` +
                        `&14=${uriInfo['14']}` +
                        `&16=${uriInfo['16']}` +
                        `&17=${uriInfo['17']}` +
                        `&18=${uriInfo['18']}` +
                        `&19=${uriInfo['19']}` +
                        `&20=${uriInfo['20']}` +
                        `&21=${uriInfo['21']}`;
        console.log(resultsurl, this.user.email)
        this.sendEmail(resultsurl,this.user.email)
        this.upsertUser()

        
        this.$router.push({ path: "/results", query: uriInfo });
    },
    onUniqueAnswer(q, val){
      store.onUniqueAnswer(q, val)
      this.uniqueInputs = store.state.uniqueAnswers
    },
    async sendEmail(url, email) {
      let submiturl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/tools/api/mailwithtemplate"; //mail
      const response = await fetch(submiturl, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
          __RequestVerificationToken: document.getElementsByName(
            "__RequestVerificationToken"
          )[0].value,
        },
        // body: JSON.stringify({resultsLink: url, email: email}),
        body: JSON.stringify({
          toAddress: email,
          templateName: "MSD_Survey_Results",
          tokens: {
            FirstName: this.user.firstName,
            SurveyLink:
              url,
          },
        }),
      }).then(function (response) {
        return response;
      });
      return response;
    },
    async upsertUser(){
      let host = window.location.host
      return  fetch('https://'+host+'/survey/upsertuser', {
                    method: "POST",
                    mode: "cors",
                    cache: "no-cache",
                    headers: {
                        'Content-Type': 'application/json',
                        '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
                    },body: JSON.stringify({ 
                         FirstName: this.user.firstName, 
                         LastName: this.user.lastName, 
                         Company:this.user.company,
                         SubSector: this.user.subsector,
                         EmailId:this.user.email
                         })}).then(data=> {return data.json()}).then(function (response) {
        // console.log("api response", response.status);
        return response['Id']
      }).then(data => this.upsertSurvey(data));
                     
    },
    async upsertSurvey(id) {
      let a = store.state.surveyAnswers
      let b = store.state.uniqueAnswers
      let host = window.location.host
      const response =  await fetch('https://'+host+'/survey/surveyupsert', {
                    method: "POST",
                    mode: "cors",
                    cache: "no-cache",
                    headers: {
                        'Content-Type': 'application/json',
                        '__RequestVerificationToken': document.getElementsByName('__RequestVerificationToken')[0].value
                    },body: JSON.stringify({ 
                          q5: a['Q5'],
                          q5_text: b['q5'] ? b['q5'] :null,
                          q6: a['Q6'],
                          q6_text: b['q6'] ? b['q6'] :null,
                          q7: a['Q7'] ? a['Q7'] :null,
                          q8: a['Q7'] ? a['Q7'] :null,
                          q9: a['Q7'] ? a['Q7'] :null,
                          q10: a['Q10'],
                          q11: `${a['Q11']['q1']},${a['Q11']['q2']}`,
                          q12: a['Q12'],
                          q13: a['Q13'],
                          q14: a['Q14'].toString(),
                          q14_text:b['q14'] ? b['q14'] :null,
                          q15: b['q15'] ? b['q15'] :null,
                          q16: a['Q16'].toString(),
                          q17: `${a['Q17']['q1']},${a['Q17']['q2']},${a['Q17']['q3']},${a['Q17']['q4']}`,
                          q18: a['Q18'],
                          q19: `${a['Q19']['q1']},${a['Q19']['q2']},${a['Q19']['q3']},${a['Q19']['q4']},${a['Q19']['q5']}`,
                          q20: a['Q20'],
                          q21: a['Q21'],
                          q22: b['q22'] ? b['q22'] :null,
                          complete: true,
                          UserId: parseInt(id),
                         })}).then(data=> {return data.json()}).then(function (response) {
        return response.status  })
    return response                     
    },
    isRadio(val){
        return [3, 5, 6, 7, 8, 9, 10, 12, 13, 18, 20, 21].includes(val)
    },
    isMatrix(val){
        return [11,17,19].includes(val)
    },
    isShortA(val){
        return [15,22].includes(val)
    },
    isCheckA(val){
        return [14,16].includes(val)
    },
    
  },
  mounted(){
    this.logo = document.getElementById('MSDlogo')
    this.scroll =  this.logo ? this.logo.getBoundingClientRect().top-100 : 0
    // console.log(this.scroll)
  }
  
};
</script>
        